import React, { useContext, useState, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import "react-bootstrap-typeahead/css/Typeahead.css";
import schoolApi from "../../api/schoolApi";
import { Helmet } from "react-helmet";
import PageNavigations from "../breadcrumbs/PageNavigations";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";
import $, { event, isEmptyObject } from "jquery";
import "jquery-ui-dist/jquery-ui.css";
import "jquery-ui-dist/jquery-ui";
import DatePicker from "react-datepicker";
import { SessionContext } from "../SessionProvider";
import reportCardApi from "../reportCard/reportCardApi";

const ExamScheduleEdit = (props) => {
  console.log("props-->", props);
  const location = useLocation();
  const { selectedSessionId, setSelectedSessionId,currentSessionId } = useContext(SessionContext);
  const [isCurrentSession,setIsCurrentSession] = useState();
  const navigate = useNavigate();
  const [examinor, setExaminor] = useState();
  const [subject, setSubject] = useState();
  const [classname, setClassname] = useState();
  const [title, setTitle] = useState();
  const [updateTitle, setUpdateTitle] = useState();
  const [sessionYear, setSessionYear] = useState([]); //Add by Aamir khan 08-05-2024
  const [currentSession, setCurrentSession] = useState();
  const [scheduleRec, setScheduleRec] = useState(location.state ? location.state : {});
  const [flage, setFlage] = useState(false);
  const [section, setSection] = useState(); //added by muskan khan 25-nov-24
  const [assignsubject, setAssignsubject] = useState([]);
  // exam types usable for the selected class (Theory, Practical, Notebook, Project …)
  const [examTypes, setExamTypes] = useState([]);
  useEffect(() => {
    if (!scheduleRec?.class_id) { setExamTypes([]); return; }
    reportCardApi.examTypes
      .list({ class_id: scheduleRec.class_id, active: 1 })
      .then((list) => {
        setExamTypes(list);
        // new paper: Theory (first type) by default; keep an inactive type of an old paper visible
        setScheduleRec((prev) => {
          if (prev.exam_type_id && list.some((t) => t.id === prev.exam_type_id)) return prev;
          if (prev.exam_type_id && prev.exam_type_name) {
            setExamTypes([...list, { id: prev.exam_type_id, name: prev.exam_type_name, marking: prev.exam_type_marking,
              needs_timetable: prev.exam_type_needs_timetable }]);
            return prev;
          }
          return prev; // no type chosen = normal paper
        });
      })
      .catch(() => setExamTypes([]));
  }, [scheduleRec?.class_id]); // eslint-disable-line react-hooks/exhaustive-deps
  const selType = examTypes.find((t) => t.id === scheduleRec?.exam_type_id);
  const isGradeType = selType?.marking === "GRADE";
  const needsTime = selType ? selType.needs_timetable !== false : true;
  const [sheduleDate, setShecduleDate] = useState({
    schedule_date: null,
    formattedStartDate: null,
    formattedEndDate: null,
  });
  console.log("location.state@@+>", location.state);

  useEffect(() => {
    async function init() {
      try {
        if (currentSessionId !== null && currentSessionId !== undefined) {
          setIsCurrentSession(selectedSessionId === currentSessionId);
        }
      } catch (error) {
        console.log('error=>', error);
      }
    }
    init();
  }, [selectedSessionId,isCurrentSession]);
  
  const handleDateChange = (date, name) => {
    if (date) {
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      const dateFormat = `${year}-${month}-${day}`;
      setShecduleDate((prevState) => ({
        ...prevState,
        [name]: date,
      }));

      setScheduleRec((prev) => {
        return { ...prev, [name]: dateFormat };
      });
    }
  };

  console.log("location == ", location.state);

  useEffect(() => {
    
    async function fetchData() {
      console.log("isCurrentSession == ",isCurrentSession)
      try {
        let fetchSelectedSessionResult;
        const sessions = await schoolApi.fetchSessions();
        if (sessions.success) {
          setSessionYear(sessions.result);
          const currentDate = new Date();
          fetchSelectedSessionResult = sessions?.result?.find((res) => {
            const startDate = new Date(res.startdate);
            const endDate = new Date(res.enddate);
            return currentDate >= startDate && currentDate <= endDate;
          });
        }
        let result;
          result = await schoolApi.fetchRelatedRecords(fetchSelectedSessionResult?.id);
          if (result.success) {
            setExaminor(result.relatedrecs[0]);
            setSubject(result.relatedrecs[1]);
            setClassname(result.relatedrecs[2]);
            setTitle(result.relatedrecs[3]);
            setUpdateTitle(result.relatedrecs[3]);
            setSection(result.relatedrecs[4]);
          }

        if (sessions.success) {
          setShecduleDate({
            formattedStartDate: fetchSelectedSessionResult?.startdate,
            formattedEndDate: fetchSelectedSessionResult?.enddate,
          });

          const titleRecords = result.relatedrecs[3].filter(
            (title) => fetchSelectedSessionResult.id === title.sessionid
          );
          setTitle(titleRecords);
          setCurrentSession(fetchSelectedSessionResult);
        } else {
          setSessionYear([]);
        }
      } catch (error) {
        console.error("An error occurred:", error);
        toast.error("Something went wrong. Please try again.");
      }
    }
    fetchData();
  }, []);
 
  // useEffect(() => {
  //   async function fetchData() {
  //     try {
  //       let fetchSelectedSessionResult;
  //       const sessions = await schoolApi.fetchSessions();
  //       if (sessions.success) {
  //         console.log("sessions.result@@+>", sessions.result);
  //         setSessionYear(sessions.result);
  //         const currentDate = new Date();
  //         fetchSelectedSessionResult = sessions?.result?.find((res) => {
  //           const startDate = new Date(res.startdate);
  //           const endDate = new Date(res.enddate);
  //           return currentDate >= startDate && currentDate <= endDate;
  //         });
  //       }
  //         const result = await schoolApi.fetchRelatedRecords(location?.state?.id ? location?.state?.sessionid : selectedSessionId);
  //         console.log('reshasda=>',result)
  //         console.log('result.relatedrecs[3]@@!@=>',result.relatedrecs[3])
  //         if (result.success) {
  //           setExaminor(result.relatedrecs[0]);
  //           setSubject(result.relatedrecs[1]);
  //           setClassname(result.relatedrecs[2]);
            
  //           setTitle(result.relatedrecs[3]);
  //           setUpdateTitle(result.relatedrecs[3]);
  //           setSection(result.relatedrecs[4]);
  //         }

  //         if (sessions.success) {
  //           setShecduleDate({
  //             formattedStartDate: fetchSelectedSessionResult?.startdate,
  //             formattedEndDate: fetchSelectedSessionResult?.enddate,
  //           });
  //           setTitle(result.relatedrecs[3]);
  //           setCurrentSession(fetchSelectedSessionResult);
  //         } else {
  //           setSessionYear([]);
  //         }
  //     } catch (error) {
  //       console.error("An error occurred:", error);
  //       toast.error(error.response.data.message);
  //     }
  //   }

  //   fetchData();
  // }, [selectedSessionId]);

  console.log('subject-->',subject);
  console.log('section-->',section);

  
  useEffect(() => {
    async function init() {
      if (location.state) {
        try {
          const result = await schoolApi.fetchExamSchedulesById(
            location.state.id
          );

          if (result.success) {
          
            setScheduleRec(result.examSchedule);

            let sectionList = await schoolApi.getSectionRecordById(
              result.examSchedule.class_id
            );
            const subjectList = await schoolApi.getAllSubByClassId(
              result.examSchedule.class_id
            );

            if (sectionList.success) {
              let sectionOptions = sectionList?.record.map((item) => ({
                value: item.id,
                label: item.name,
              }));
              setSection(sectionOptions);
            } else {
              setSection([]);
            }

            if (subjectList.success) {
              let fetch = subjectList.records.map((item) => ({
                label: item.subjectname,
                value: item.subject_id,
              }));
              setAssignsubject(fetch);
            } else {
              setAssignsubject([]);
            }
            setShecduleDate((prev) => ({
              ...prev,
              schedule_date: new Date(result.examSchedule?.schedule_date),
            }));
          } else {
            setScheduleRec([]);
            toast.warn("No data found for the provided ID.");
          }
        } catch (err) {
          toast.error(
            "Failed to fetch exam schedules. Please try again later."
          );
        }
      }
    }
    init();
  }, [location?.state?.id, section?.length>0, subject?.length>0]);

  const handleChange = async (e) => {
    try {
      let { name, value } = e.target;
      if (name === "max_marks") {
        if (value.includes(" ")) {
          return;
        }
      }
      if (e.target,name === "sessionid" && selectedSessionId) {
        return toast.error("You can only select the current session!");
      }
      if (name === "class_id" || name === "section_id") {
        let class_id =
          name === "class_id" ? e.target.value : scheduleRec.class_id;
        if (isEmptyObject(e.target.value) && name === "class_id") {
          setScheduleRec({ ...scheduleRec, [e.target.name]: e.target.value });
          setScheduleRec((prev) => ({
            ...prev,
            section_id: "",
            subject_id: "",
          }));
          setAssignsubject([]);
          setSection([]);
          return;
        }
        setScheduleRec({ ...scheduleRec, [e.target.name]: e.target.value });
        let sectionList = await schoolApi.getSectionRecordById(class_id);
        if (sectionList.success) {
          let sectionOptions = sectionList?.record.map((item) => ({
            value: item.id,
            label: item.name,
          }));
          setSection(sectionOptions);
          if (name === "class_id") {
            setAssignsubject([]);
            setScheduleRec((prev) => ({
              ...prev,
              section_id: "",
              subject_id: "",
            }));

            const result = await schoolApi.getAllSubByClassId(class_id);
            if (result.success) {
              let subjectList = result.records.map((item) => ({
                value: item.subject_id,
                label: item.subjectname,
              }));
              setAssignsubject(subjectList);
            } else {
              toast.error("Assign a subject to the selected class");
            }
          }
        } else {
          toast.error("Section not found!");
        }
      } else {
        setScheduleRec({ ...scheduleRec, [e.target.name]: e.target.value });
      }
    } catch (error) {
      toast.error("Please add a section and subject for the selected class.");
    }
  };

  const calculateDuration = () => {
    if (!scheduleRec.start_time || !scheduleRec.end_time) return;
    const startTime = new Date(`01/01/2000 ${scheduleRec.start_time}`);
    const endTime = new Date(`01/01/2000 ${scheduleRec.end_time}`);
    const diff = endTime - startTime;

    if (!isNaN(diff)) {
      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor((diff / (1000 * 60)) % 60);
      const totalMinutes = hours * 60 + minutes;

      if (totalMinutes <= 0) {
        setScheduleRec((prevRecs) => ({
          ...prevRecs,
          duration: 0,
          status: "Upcoming",
        }));
        if (flage) toast.error("End time must be greater than start time.");
        return;
      }
      setScheduleRec((prevRecs) => ({
        ...prevRecs,
        duration: totalMinutes,
        status: "Upcoming",
      }));
    }
  };

  useEffect(() => {
    calculateDuration();
    setFlage(false);
  }, [scheduleRec?.start_time, scheduleRec?.end_time]);

  const handleCheckbox = (e) => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setScheduleRec((prevRecs) => ({
      ...prevRecs,
      [e.target.name]: value === "on" ? true : value === "" ? false : value,
    }));
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      if (!scheduleRec.year) {
        scheduleRec.year = currentSession.year;
        scheduleRec.sessionid = currentSession.id;
      }
      if (isGradeType) {
        scheduleRec.max_marks = 0;
        scheduleRec.min_marks = 0;
      } else if (scheduleRec.max_marks) {
        scheduleRec.min_marks = Math.ceil(0.33 * scheduleRec.max_marks);
      }
      if (
        !scheduleRec.exam_title_id ||
        !scheduleRec.class_id ||
        !scheduleRec.subject_id ||
        !scheduleRec.examinor_id ||
        (needsTime && (!scheduleRec.schedule_date || !scheduleRec.start_time || !scheduleRec.end_time)) ||
        (!isGradeType && !scheduleRec.max_marks) ||
        !scheduleRec.section_id
      ) {
        toast.error("Fill all required values!!!");
        return;
      }

      if (!isGradeType && parseInt(scheduleRec.min_marks) >= parseInt(scheduleRec.max_marks)) {
        return toast.error("max marks should be greater than min marks");
      }

      if (scheduleRec.start_time && scheduleRec.end_time && scheduleRec.start_time >= scheduleRec.end_time) {
        toast.error("Start time should not be greater than end time!!!");
        return;
      }

      let result2 = {};
      let result1 = {};
      if (scheduleRec.id) {
      //  scheduleRec.sessionid = selectedSessionId;
        console.log('scheduleRec@#233=>',scheduleRec)
        result2 = await schoolApi.updateExamSchedule(
          scheduleRec.id,
          scheduleRec
        );
        if (result2.success) {
          toast.success("Record updated succefully");
          setTimeout(() => {
            navigate(`/examschedule`);
          }, 1000);
        } else {
          toast.error(result2.message);
        }
      } else {
        try {
          console.log('scheduleRec@@+>',scheduleRec)
          scheduleRec.sessionid = selectedSessionId;
          const result1 = await schoolApi.createExamSchedule(scheduleRec);
          if (result1.data.success) {
            toast.success(result1.data.message);
            setTimeout(() => {
              navigate(
                `/examscheduleview/${result1?.data.examScheduleResult.id}`
              );
            }, 1200);
          } else {
            toast.error(result1.data.message);
          }
        } catch (error) {
          toast.error(result1.data.message);
        }
      }
    } catch (error) {
      return toast.error("Session record not found");
    }
  };

  const handleCancel = () => {
    if (location?.state?.id) {
      navigate("/examscheduleview/" + location?.state?.id);
    } else {
      navigate("/examschedule");
    }
  };

  return (
    <>
      <ToastContainer />
      <Helmet>
        <title>{props?.tabName}</title>
      </Helmet>
      <PageNavigations
        id={location.state?.id}
        listName={
          props?.selectedDepartment === "scheduleEdit" ? "" : "ScheduleNewExam"
        }
        listPath={
          location?.pathname?.split("/")[1] === "/examschedule"
            ? ""
            : "/examschedule"
        }
        viewName="Exam Edit"
        viewPath={"/examscheduleview/" + location.state?.id}
        colLg={10}
        colClassName="d-flex px-3 py-2"
        extrColumn={2}
      />
      <Container className="view-form">
        <Row>
          <Col></Col>
          <Col lg={8}>
            <Form className="mt-3" onSubmit={handleSubmit}>
              <Row className="view-form-header align-items-center">
                <Col lg={3}>Exam Details</Col>
                <Col lg={9} className="d-flex justify-content-end">
                  <Button className="btn-sm mx-2" disabled={isCurrentSession === false?true:false} onClick={handleSubmit}>
                    {" "}
                    Save{" "}
                  </Button>
                  <Button
                    className="btn-sm"
                    variant="danger"
                    disabled={isCurrentSession === false?true:false}
                    onClick={handleCancel}
                  >
                    Cancel
                  </Button>
                </Col>
              </Row>
              <Row>
                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label className="form-view-label">
                      Exam Title
                    </Form.Label>
                    <Form.Select
                      name="exam_title_id"
                      onChange={handleChange}
                      value={scheduleRec.exam_title_id ?? ""}
                      required
                    >
                      <option value="">--Select Title --</option>
                      {title &&
                        title.map((res) => (
                          <option key={res.title} value={res.id}>
                            {res.title}
                          </option>
                        ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label className="form-view-label">Class</Form.Label>
                    <Form.Select
                      name="class_id"
                      onChange={(e) => {
                        handleChange(e);
                      }}
                      value={scheduleRec.class_id ?? ""}
                      required
                    >
                      <option value="">--Select Class --</option>
                      {classname &&
                        classname.map((res) => (
                          <option key={res.classname} value={res.id}>
                            {res.classname}
                          </option>
                        ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label className="form-view-label">Section</Form.Label>
                    <Form.Select
                      disabled={!scheduleRec.class_id}
                      name="section_id"
                      onChange={handleChange}
                      value={scheduleRec.section_id ?scheduleRec.section_id: ""}
                      required
                    >
                      <option value="">-- Select Section --</option>
                      {section &&
                        section?.map((section) => (
                          <option key={section.id} value={section.value}>
                            {section.label}
                          </option>
                        ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label className="form-view-label">Subject</Form.Label>
                    <Form.Select
                      disabled={!scheduleRec.class_id}
                      name="subject_id"
                      onChange={handleChange}
                      value={scheduleRec.subject_id ? scheduleRec.subject_id : ""}
                      required
                    >
                      <option value="">-- Select Subject --</option>
                      {assignsubject?.map((subject) => (
                        <option key={subject.id} value={subject.value}>
                          {subject.label}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label className="form-view-label">
                      Examinor
                    </Form.Label>
                    <Form.Select
                      required
                      name="examinor_id" //change by Aamir khan 09-05-2024
                      onChange={handleChange}
                      value={scheduleRec.examinor_id ? scheduleRec.examinor_id : ""}
                    >
                      <option value="">-- Select Examinor --</option>
                      {examinor &&
                        examinor.map((res) => (
                          <option key={res.id} value={res.id}>
                            {res.examinor_name}
                          </option>
                        ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicLastName"
                    >
                      Date
                    </Form.Label>
                    <DatePicker
                      required={needsTime}
                      selected={sheduleDate?.schedule_date ? sheduleDate?.schedule_date : null}
                      onChange={(date) =>
                        handleDateChange(date, "schedule_date")
                      }
                      dateFormat="dd-MM-yyyy"
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      // any date inside the current session (old exams can be corrected too)
                      minDate={sheduleDate?.formattedStartDate ? new Date(sheduleDate.formattedStartDate) : null}
                      maxDate={sheduleDate?.formattedEndDate ? new Date(sheduleDate.formattedEndDate) : null}
                      placeholderText="Select a date"
                      className="form-control"
                      style={{ width: "300px" }}
                      onKeyDown={(e) => e.preventDefault()}
                      highlightDates={[new Date()]}
                    />
                  </Form.Group>
                </Col>
                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicPhone"
                    >
                      Start Time
                    </Form.Label>
                    <Form.Control
                      type="time"
                      name="start_time"
                      placeholder="--Enter Start Time--"
                      value={scheduleRec.start_time ? scheduleRec.start_time : ""}
                      onChange={handleChange}
                      required={needsTime}
                    />
                  </Form.Group>
                </Col>
                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicEmail"
                    >
                      End Time
                    </Form.Label>
                    <Form.Control
                      type="time"
                      name="end_time"
                      placeholder="Enter End Time"
                      value={scheduleRec.end_time ? scheduleRec.end_time : ""}
                      onChange={handleChange}
                      required={needsTime}
                    />
                  </Form.Group>
                </Col>
                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicBirthdate"
                    >
                      Room Number
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="room_no"
                      placeholder="--Enter Room Number--"
                      value={scheduleRec.room_no ? scheduleRec.room_no : ""}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicEmail"
                    >
                      Duration
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="duration"
                      placeholder="--Enter Duration--"
                      value={
                        scheduleRec.duration === undefined
                          ? 0
                          : `${scheduleRec.duration} minutes`
                      }
                      onChange={(e) => {
                        const value = e.target.value.replace(" minutes", "");
                        handleChange({ target: { name: "duration", value } });
                      }}
                      disabled
                    />
                  </Form.Group>
                </Col>
                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label className="form-view-label">Status</Form.Label>
                    {scheduleRec.id && (
                      <Form.Select
                        name="status"
                        value={scheduleRec.status ?? ""}
                        onChange={handleChange}
                        required
                      >
                        {!location?.state?.exam_title_id ? (
                          <option value="">--Select Status--</option>
                        ) : (
                          ""
                        )}
                        <option value="Completed">Completed</option>
                        <option value="Pending">Pending</option>
                        <option value="Upcoming">Upcoming</option>
                      </Form.Select>
                    )}
                    {!scheduleRec.id && (
                      <Form.Select
                        name="status"
                        value={scheduleRec?.status ?? ""}
                        onChange={handleChange}
                        disabled
                      >
                        <option value="Upcoming">Upcoming</option>
                      </Form.Select>
                    )}
                  </Form.Group>
                </Col>
                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicQualification"
                    >
                      Max Marks
                    </Form.Label>
                    <Form.Control
                      required={!isGradeType}
                      disabled={isGradeType}
                      min={1}
                      type="phone"
                      name="max_marks"
                      placeholder={isGradeType ? "Grade only – no marks" : "--Enter Max Marks--"}
                      value={isGradeType ? "" : scheduleRec.max_marks ?? ""}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value === "" || /^[0-9]+$/.test(value)) {
                          handleChange(e);
                        }
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdharnumber"
                    >
                      Min Marks(33%)
                    </Form.Label>
                    <Form.Control
                      min={0}
                      type="number"
                      name="min_marks"
                      placeholder="--Enter Min Marks--"
                      value={Math.ceil(0.33 * scheduleRec.max_marks) ?? 0}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value === "" || /^[0-9]+$/.test(value)) {
                          handleChange(e);
                        }
                      }}
                      disabled="true"
                    />
                  </Form.Group>
                </Col>

                <Col lg={6} className="">
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicFirstName"
                    >
                      Session
                    </Form.Label>
                    <Form.Select
                      name="sessionid"
                      value={scheduleRec?.sessionid ? scheduleRec?.sessionid : selectedSessionId}
                      onChange={handleChange}
                      disabled={scheduleRec?.sessionid}
                    >
                      {sessionYear.map((session) => (
                        <option key={session.id} value={session.id}>
                          {session.year}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col lg={5} className="mx-2">
                  <Form.Group className="p-2">
                    <Form.Label className="form-view-label" htmlFor="exam_type_id">
                      Exam Type <small className="text-muted">(optional)</small>
                    </Form.Label>
                    <Form.Select
                      id="exam_type_id"
                      value={scheduleRec.exam_type_id ?? ""}
                      disabled={!scheduleRec.class_id}
                      onChange={(e) => setScheduleRec((prev) => ({ ...prev, exam_type_id: e.target.value || null }))}
                    >
                      <option value="">{scheduleRec.class_id ? "No type (normal paper)" : "Select class first"}</option>
                      {examTypes.map((t) => (
                        <option key={t.id} value={t.id}>
                          {t.name}{t.marking === "GRADE" ? " (grade)" : ""}
                        </option>
                      ))}
                    </Form.Select>
                    {selType && (
                      <small className="text-muted">
                        {isGradeType ? "Grade only, not added to total marks. " : ""}
                        {needsTime ? "Date and time are required." : "Date / time optional (not shown in exam timetable)."}
                      </small>
                    )}
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </Col>
          <Col></Col>
        </Row>
      </Container>
    </>
  );
};
export default ExamScheduleEdit;